import { Icon } from "semantic-ui-react";

function Situacoes({ situacaoFiliacao }) {
  
  return (
    <ul className="situacoesFiliacao">
      <li>
        <div className="icone feito">
          <Icon name="check" />
        </div>
        <span>Pedido recebido pelo diretório</span>
      </li>
      <li>
        <div
          className={
            situacaoFiliacao === 4
              ? "icone fazendo"
              : [2, 3, 5, 6].includes(situacaoFiliacao)
              ? "icone feito"
              : "icone"
          }
        >
          {[2, 3, 4, 5, 6].includes(situacaoFiliacao) ? (
            <Icon
              name={situacaoFiliacao === 4 ? "warning" : "check"}
            />
          ) : null}
        </div>
        <span>Atividade realizada</span>
      </li>
      <li>
        <div
          className={
            [2,3].includes(situacaoFiliacao)
              ? "icone fazendo"
              : [5, 6].includes(situacaoFiliacao)
              ? "icone feito"
              : "icone"
          }
        >
          {[2, 3, 5, 6].includes(situacaoFiliacao) ? (
            <Icon
              name={[2,3].includes(situacaoFiliacao) ? "warning" : "check"}
            />
          ) : null}
        </div>
        <span>Pedido em Análise</span>
      </li>
      <li>
      <div
          className={
            situacaoFiliacao === 5
              ? "icone fazendo"
              : [6].includes(situacaoFiliacao)
              ? "icone feito"
              : "icone"
          }
        >
          {[5, 6].includes(situacaoFiliacao) ? (
            <Icon
              name={situacaoFiliacao === 5 ? "warning" : "check"}
            />
          ) : null}
        </div>
        <span>Pedido Aprovado</span>
      </li>
    </ul>
  );
}

export default Situacoes;
